// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7208) return "static/chunks/7208-816b226dde32189c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1859":"8d423dd7749e0ae9","3772":"3d436a20299c693f"}[chunkId] + ".js";
};